import { TypeListener } from './event-product-fruits-interface'

const action = (event: CustomEvent) => {
  if (event?.detail?.id === 'redirect-product-pf') {
    postMessage({
      type: 'THIRD-PARTY-APP.REDIRECT',
      body: { route: { name: '/products/bw/add/1/info' } }
    })
  }
}

export const actionProductFruits = (typeListener: TypeListener) => {
  if (typeListener === 'add') {
    window?.addEventListener('productfruits_card_custom_btn_click', action)
  }

  if (typeListener === 'remove') {
    window?.removeEventListener('productfruits_card_custom_btn_click', action)
  }
}
